// ---------------------------------------------------------------------------
// "Usuario A" — la única cuenta que puede ver y usar los submenús marcados con
// `submenus.solo_usuarioa = true` (Administrar Menús, Logs de Actividad,
// Rastreo de CLABEs, A/B Tests, etc.).
//
// El correo estaba repetido en cinco archivos (`useDynamicMenus`,
// `LogsActividad`, `RastreoClabeSTP`, ...), cada uno comparando a su manera y
// solo para pintar el sidebar u ocultar UNA vista. Ninguno gobernaba la
// autorización de la ruta, así que un rol con permiso de lectura en BD sobre
// uno de esos submenús entraba escribiendo la URL. Aquí queda la definición
// única que consume el gate central (`useAllowedMenus`).
// ---------------------------------------------------------------------------

/**
 * Las cuentas con acceso a esas vistas. Las vistas siguen cerradas para
 * cualquier cuenta que no esté en esta lista, sin importar su rol (incluidos
 * los demás Super Admin).
 *
 * OJO: esta lista solo cierra la RUTA en el navegador. Quién puede ESCRIBIR en
 * `menus`, `submenus` y `submenus_permisos_disponibles` lo decide
 * `public.es_usuario_a()` en la BD (ver
 * `Ejecuciones_manuales/20261008_administrar_menus_solo_usuario_a.md`,
 * documento local, no versionado). Si se suma o quita un correo aquí, hay que
 * hacer lo mismo allá.
 */
export const USUARIOS_A = [
  'jorge.mendoza@sozu.com',
] as const;

/** El primero de la lista. Se mantiene para quien todavía compara contra un
 *  correo suelto; lo correcto es preguntar con `esUsuarioA`. */
export const USUARIO_A_EMAIL = USUARIOS_A[0];

/**
 * ¿El correo es el de Usuario A? Comparación normalizada (minúsculas y sin
 * espacios): el correo llega de `profile.email` y de `user.email`, y basta una
 * diferencia de capitalización para negarle el acceso a su propio dueño.
 */
export function esUsuarioA(email?: string | null): boolean {
  if (!email) return false;
  const normalizado = email.trim().toLowerCase();
  return USUARIOS_A.some((permitido) => permitido === normalizado);
}
